<template>
  <el-dialog custom-class="mobile-dialog" :visible.sync="admissionVisible" width="850px" class="addmission-container"
    :before-close="handleCancel" append-to-body top="6vh">
    <div id="printable" ref="printable">
      <div slot="title" class="dialog-title">
        <h3 v-if="examTable && examTable[0] && examTable[0].title">{{ examTable[0].title }}</h3>
        <h3>准考证</h3>
      </div>


      <el-card class="card-container">
        <div class="admission-dialog-body">
          <div class="dialog-base-box">
            <div class="dialog-body-title">身份信息</div>
            <div class="dialog-base-content">
              <div class="dialog-base">
                <p v-if="examInfo.applyName">姓名: {{ examInfo.applyName }}</p>
                <p v-if="examInfo.gender.msg">性别: {{ examInfo.gender.msg }}</p>
                <p v-if="examInfo.identityNum">身份证号: {{ examInfo.identityNum }}</p>
                <p>准考证号: {{ examInfo.examNumber }}</p>
                <p v-if="examInfo.institutionName">所属学校: {{ examInfo.institutionName }}</p>
                <p v-if="examInfo.institutionName">层次: {{ examInfo.eduSystem.msg }}</p>
                <p v-if="examInfo.institutionName">专业: {{ examInfo.majorName }}</p>

<!--                <view class="item">
                  准考证号: {{ pageState.examInfo.examNumber }}
                </view>
                <view class="item">
                  所属学校: {{ pageState.examInfo.institutionName }}
                </view>

                <view class="item">
                  层次: {{ pageState.baseInfoObj.eduSystem.msg }}
                </view>
                <view class="item">
                  专业: {{ pageState.baseInfoObj.majorName }}
                </view>-->

              </div>
              <div v-if="examInfo.avatar" class="dialog-base-img">
                <img :src="resolveImg(examInfo.avatar)" alt="" class="base-img" />
              </div>
              <div v-else class="dialog-base-img" style="border: 1px solid #EBEEF5;display: flex;justify-content: center;align-items: center;">
                暂无照片
              </div>
            </div>
          </div>
          <div>
            <div class="dialog-body-title">考试安排</div>
            <div class="dialog-exam" style="padding: 20px">
              <el-table :data="examTable" style="width: 100%" border fit>
                <el-table-column prop="title" label="考点名称" align="center" />
                <el-table-column prop="subjectName" label="考试科目" align="center" />
                <el-table-column prop="examTime" label="考试时间" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.examTime | parseTime }}
                  </template>
                </el-table-column>
                <el-table-column prop="examDuration" label="考试时长" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.examDuration }}分钟
                  </template>
                </el-table-column>
                <el-table-column prop="hallAddress" label="考试地址" align="left" />
                <el-table-column prop="examRoom" label="考场号" align="center" />
                <el-table-column prop="examSeat" label="座位号" align="center" />
              </el-table>
            </div>
          </div>
          <div class="dialog-notice">
            <div class="dialog-body-title">考试须知</div>
            <div v-if="getTemplateListData[0]['enable'] == 1" style="padding: 20px"
              v-html="getTemplateListData[0].propertyValue">

            </div>
          </div>
<!--          <div class="dialog-notice">
            <div class="dialog-body-title">考点提示</div>
            <div v-if="getTemplateListData[1]['enable'] == 1" style="padding: 20px">
              {{ getTemplateListData[1].propertyValue }}
            </div>
          </div>-->
        </div>
      </el-card>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="print">打印</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { parseTime } from '@/utils/time'
import { resolveImg } from '@/utils/imgFill'
import { examUserPrintTicketRecord } from '../api/printNTS'
export default {
  name: 'AdmissionTem',
  props: {
    adVisible: {
      type: Boolean,
      default: false
    },
    admissionObj: {
      type: Object,
      default: () => { }
    },
    baseInfoObj: {
      type: Object,
      default: () => { }
    },
    row: {
      type: Object,
      default: () => { }
    },
    userS: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      admissionVisible: false,
      getTemplateListData: [{}, {}],
      examInfo: {
        examNumber: '', //准考证号
        applyName: '', //姓名
        gender: { msg: '' }, //性别
        identityNum: '', //身份证号
        institutionName: '', //学校
        avatar: '' //证件照
      },
      examTable: [],
      admissVisible: false
    }
  },
  watch: {
    baseInfoObj(value) {
      console.log(">>>>>>>>>>value",value)
      this.$store.dispatch('getTemplateList', this.row.examId).then(res => {
        if (res) {
          if (res.length) {
            if (res.length === 1) {
              res.push({})
              this.getTemplateListData = res
            } else {
              console.log(res, 999)
              this.getTemplateListData = res
            }
          } else {
            this.getTemplateListData = [{}, {}]
          }

          console.log(res)
          this.admissionVisible = true
        }
      })
      const dataList = value.examUserDetailModels.map(item => {
        return {
          title: value.title,
          subjectName: item.examDetailModel.subjectName,
          examTime: item.examDetailModel.examTime,
          examDuration: item.examDetailModel.examDuration,
          examRoom: item.examRoom,
          examSeat: item.examSeat,
          hallAddress: item.hallAddress
        }
      })
      this.examTable = dataList
      let examInfo = {
        examNumber: '', //准考证号
        applyName: '', //姓名
        gender: { msg: '' }, //性别
        identityNum: '', //身份证号
        institutionName: '', //学校
        avatar: '', //证件照
        ...value.examUserBaseModel
      }
      if (Object.keys(value).length) {
        Object.keys(value).forEach(key => {
          if (examInfo.hasOwnProperty(key)) {
            examInfo[key] = value[key]
          }
        })
      }
      this.examInfo = examInfo
    }
  },
  methods: {
    resolveImg,
    admissionDownLoad() { },
    handleCancel() {
      this.admissionVisible = false
    },
    print() {
      // console.log(ewq);
      this.$refs.printable.style.overflow = 'hidden'
      this.$printJS({
        printable: 'printable',
        type: 'html',
        targetStyles: ['*'], // 需要保留的样式，*代表所有
        style:
          '@page { size: auto;  margin: 0mm; } @media print { body { margin: 0mm; size:portrait } @page {size:portrait} }'
      })
      console.log(this.userS);
      const data = {
        "examid": this.userS.examId,
        "isprint": 1,
        "userid": this.userS.userId
      }
      // 开始打印
      examUserPrintTicketRecord(data).then(res => {
        console.log(res);
      })
    }
  },
  computed: {},
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}') || '--'
    }
  }
}
</script>
<style lang="scss">
.addmission-container {
  .dialog-title {
    text-align: center;
  }

  .admission-dialog-body {
    width: 100%;
    min-height: 500px;
    //border: 1px black solid;

    .dialog-base-box {
      min-height: 130px;
      position: relative;

      .dialog-base-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
      }

      .dialog-base {
        flex: 1;
      }

      .dialog-base-img {
        //position: absolute;
        //top: 24px;
        //right: 25px;
        width: 127px;
        height: 145px;
        //line-height: 175px;
        //border: 1px black solid;
        //text-align: center;
        //background-color: rgb(231, 231, 231);
      }
    }

    .base-img {
      width: 100%;
      height: 100%;
    }

    .dialog-exam {
      margin: 5px;
    }

    .dialog-notice {
      min-height: 70px;
      margin-top: 10px;
    }

    .dialog-body-title {
      padding-left: 2px;
      height: 20px;
      line-height: 20px;
      //border-bottom: 1px black solid;
      //border-top: 1px black solid;
      font-size: 16px;
      font-weight: bold;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 0px 20px;
  }
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .mobile-dialog {
    width: 90% !important;
  }

  .el-table__body-wrapper {
    overflow-x: auto;
  }

  .dialog-base-img {
    scale: 80%;
    right: 0 !important;
  }

  .dialog-base-content {
    padding: 0 !important;
  }

  .dialog-exam {
    padding: 0 !important;
  }
}
</style>
